import { render, staticRenderFns } from "./RelatorioDeAbsenteismo2.vue?vue&type=template&id=0ed1c173"
import script from "./RelatorioDeAbsenteismo2.vue?vue&type=script&lang=js"
export * from "./RelatorioDeAbsenteismo2.vue?vue&type=script&lang=js"
import style0 from "./RelatorioDeAbsenteismo2.vue?vue&type=style&index=0&id=0ed1c173&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports